import { render, staticRenderFns } from "./VaultController.vue?vue&type=template&id=703b4c4b&scoped=true&"
import script from "./VaultController.vue?vue&type=script&lang=ts&"
export * from "./VaultController.vue?vue&type=script&lang=ts&"
import style0 from "./VaultController.vue?vue&type=style&index=0&id=703b4c4b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703b4c4b",
  null
  
)

export default component.exports